import React, { PropTypes } from 'react';
import classNames from 'classnames';

import './styles.scss';


const SortableHeader = (props, { sortBy, sortDesc }) => {
  const { className, sortParam, colSpan, onSort, children } = props;
  return (
    <th
      className={classNames('sortable', className, sortParam, {
        sort: sortParam === sortBy,
        [`sort-${sortDesc ? 'desc' : 'asc'}`]: sortParam === sortBy,
      })}
      colSpan={colSpan}
      onClick={() => onSort(sortParam, true)}
      styleName='sortable'
    >

      { children }

      <div styleName='sort-control'>

        <button
          type='button'
          className='btn asc'
          styleName='asc'
          onClick={() => onSort(sortParam, false)}
        >
          &#9650;
        </button>

        <button
          type='button'
          className='btn desc'
          styleName='desc'
          onClick={() => onSort(sortParam, true)}
        >
          &#9660;
        </button>

      </div>

    </th>
  );
};

SortableHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  onSort: PropTypes.func,
  sortParam: PropTypes.string,
};

SortableHeader.defaultProps = {
  children: null,
  className: null,
  colSpan: null,
  onSort: () => {},
  sortParam: null,
};

SortableHeader.contextTypes = {
  sortBy: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default SortableHeader;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserRankings/SortableHeader.jsx